export function getClass(classKey) {
  if (!classKey) return "1";
  const normalized = String(classKey).toLowerCase();

  if (normalized === "2h" || normalized === "2g") return "2b";
  if (normalized === "9") return "8";
  if (
    ["1", "2a", "2b", "3", "4", "5", "6", "7", "8"].includes(normalized)
  ) {
    return normalized;
  }

  return "1";
}

export function getClassIndex(classKey) {
  if (!classKey) return "1";
  const normalized = String(classKey).toLowerCase();

  if (normalized === "2h" || normalized === "2g") return "2b";
  if (normalized === "9") return "8";
  if (
    ["1", "2a", "2b", "3", "4", "5", "6", "7", "8"].includes(normalized)
  ) {
    return normalized;
  }

  return "1";
}

export const normalizeCurrencyInput = (s) => s.replace(/[^\d.-]/g, "");
